import React from "react";
import Text from "antd/es/typography/Text";
import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ScanStatuses } from "@/utils/enum";
import ScanStatusBadge from "@/pages/AdminShipments/AdminShipmentView/ScanStatusList/ScanStatusBadge";

const ScanStatusItem = ({ title, status, onEdit }) => {
  return (
    <div style={{ display: "flex" }}>
      <div>
        <Text strong style={{ fontSize: "inherit" }}>
          {title}
        </Text>
        <div>
          <ScanStatusBadge status={status ?? ScanStatuses.NOT_SCANNED} />
        </div>
      </div>

      <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={onEdit}
        style={{
          borderRadius: 10,
          color: "#fff",
          marginLeft: "10px",
        }}
      />
    </div>
  );
};

export default ScanStatusItem;
